var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSocialTwitter28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.927 7.667a8.363 8.363 0 0 1-2.065.59c.332-.057.821-.656 1.016-.899.296-.365.521-.783.665-1.23 0-.034.033-.082 0-.105a.114.114 0 0 0-.11 0c-.771.418-1.593.738-2.445.95a.17.17 0 0 1-.171-.042 2.376 2.376 0 0 0-.214-.224 4.454 4.454 0 0 0-1.168-.756 4.105 4.105 0 0 0-1.82-.3 4.4 4.4 0 0 0-1.728.476 4.48 4.48 0 0 0-1.367 1.16 4.394 4.394 0 0 0-.832 1.664 4.57 4.57 0 0 0-.042 1.758c0 .1 0 .114-.086.1-3.386-.499-6.164-1.701-8.434-4.282-.1-.115-.152-.115-.233 0-.988 1.502-.508 3.878.727 5.052.166.157.337.31.517.452a4.237 4.237 0 0 1-1.624-.452c-.095-.062-.147-.028-.152.086a2.802 2.802 0 0 0 0 .475 4.318 4.318 0 0 0 2.66 3.442c.172.074.352.13.536.166a4.853 4.853 0 0 1-1.59.048c-.115-.024-.157.038-.115.147.698 1.901 2.213 2.481 3.325 2.804.152.024.304.024.475.062l-.029.029c-.328.599-1.653 1.003-2.26 1.212a8.12 8.12 0 0 1-3.467.447c-.185-.029-.228-.024-.276 0-.047.023 0 .076.052.123a11.366 11.366 0 0 0 3.04 1.378c4.17 1.15 8.862.305 11.991-2.809 2.46-2.443 3.325-5.813 3.325-9.188 0-.128.157-.204.247-.27a8.156 8.156 0 0 0 1.629-1.702.5.5 0 0 0 .114-.343c0-.071 0-.057-.09-.019Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialTwitter28);
export default __webpack_public_path__ + "static/media/social-twitter_28.37d35ce0.svg";
export { ForwardRef as ReactComponent };